import { AiOutlineProfile } from "react-icons/ai";
import { MdLogin, MdOutlineIntegrationInstructions, MdOutlinePassword, MdOutlineSync } from "react-icons/md";

//  Page Title: LDAP/AD Integration for WordPress Sites
export const ldapData = [
    {
        title: "LDAP/Active Directory Login Integration for WordPress Sites",
        video: true,
        videoId: "O4FKNvgJpbY",
        videoType: "youtube",
        icon: <MdOutlineIntegrationInstructions className='text-white fs-5' />
    },
    {
        title: "LDAP/ Active Directory User Sync with WordPress using miniOrange",
        video: true,
        videoId: "64N-3-bd7Nk",
        videoType: "youtube",
        icon: <MdOutlineSync className='text-white fs-5' />
    },
    {
        title: "Auto Login/SSO with Kerberos NTLM in WordPress site",
        video: true,
        videoId: "N1L1iiV8CmA",
        videoType: "youtube",
        icon: <MdLogin className='text-white fs-5' />
    },
    {
        title: "Active Directory Self-Service Password Reset using WordPress",
        video: true,
        videoId: "swphtxwECfI",
        videoType: "youtube",
        icon: <MdOutlinePassword className='text-white fs-5' />
    },
    {
        title: "Staff/Employee Business Directory for Active Directory",
        video: true,
        videoId: "0zLrHDW8vm8",
        videoType: "youtube",
        icon: <AiOutlineProfile className='text-white fs-5' />
    }
]